import styled from 'styled-components';
import media from '../../../../constants/media';
import { Label } from '../../../base/forms/label';
import { Flex } from '../../../base/misc/misc';

export const Wrapper = styled.div`
	margin-bottom: 15rem;
`;

export const ShipmentNumberWrapper = styled.div`
	margin-bottom: 6rem;
`;

export const ShipmentNumberLabel = styled(Label)`
	margin-right: 1rem;
	transform: translateY(6px);
`;

export const StyledFlex = styled(Flex)`
	${media.mobileOnly`
		flex-wrap: wrap;
		justify-content: center;
		a {
			margin-bottom: 2rem;
		}
	`}
`;

export const ButtonWrapper = styled.div`
	display: flex;
`;

export const ButtonContentWrapper = styled.div`
	display: flex;
	p {
		margin-bottom: 0;
	}
`;
